import React from 'react';
import {Link} from "react-router-dom";
import CalltoActionSeven from "../../elements/calltoaction/CalltoActionSeven";
import ScrollTop from "./ScrollTop";
import { FiTwitter, FiLinkedin } from "react-icons/fi";
import { FaAndroid, FaDiscord, FaApple} from "react-icons/fa";
import { useTranslation } from "react-i18next";
export const getFlag = (lang) => `/icons/icon-lang-${new String(lang).toLowerCase().split("-")[0]}.png`;


const FooterTwo = () => {
    const { t, i18n } = useTranslation('enterprise');
    const handleChange = (event) => {
      i18n.changeLanguage(event.target.value);
    };
    return (
        <>
            <footer className="rn-footer footer-style-default variation-two">
                <CalltoActionSeven />
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/* Start Principle Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{t('footer.principe')}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            <li><Link to='/functioning'>{t('footer.fonctionnement')}</Link></li>
                                            <li><Link to='/benefits'>{t('footer.whyUs')}</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End Principle Widget  */}

                            {/* Start One-stop shop Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title">{t('footer.offres')}</h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                <li><Link to='/employee-savings'>{t('footer.epargneSalariale')}</Link></li>
                                                <li><Link to='/access-capital'>{t('footer.capital')}</Link></li>
                                                <li><Link to='/cse'>{t('footer.cse')}</Link></li>
                                                <li><Link to='/bonus-reward'>{t('footer.primesBonus')}</Link></li>
                                                <li><Link to='/donations'>{t('footer.donations')}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End One-stop shop Widget  */}

                            {/* Start About Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{t('footer.about')}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            <li><Link to='/legal-notice'>{t('footer.mentionsLegales')}</Link></li>
                                            <li><Link to='/privacy-policy'>{t('footer.politiqueConfidentialite')}</Link></li>
                                            <li><Link to='/cookies-policy'>{t('footer.gestionCookies')}</Link></li>
                                            <li><Link to='/about-us'>{t('footer.quiSommesNous')}</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End About Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{t('footer.staywith')}</h4>
                                    <div className="inner">
                                        <h6 className="subtitle">{t('footer.feelfree')}</h6>
                                        <ul className="social-icon social-default justify-content-start mb-4">          
                                        <li><a href="https://twitter.com/N01zet" target="_blank" rel="noreferrer"><FiTwitter /></a></li>
                                        <li><a href="https://www.linkedin.com/company/n01zet" target="_blank" rel="noreferrer"><FiLinkedin /></a> </li>
                                        <li><a href="https://discord.com/invite/cxgnzF43BT" target="_blank" rel="noreferrer"> <FaDiscord /></a> </li>
                                        <li><a href="https://testflight.apple.com/join/qnPblFSD" target="_blank" rel="noreferrer"><FaApple /></a> </li>
                                        <li><a href="https://play.google.com/apps/testing/com.n01zet.n01zet" target="_blank" rel="noreferrer"><FaAndroid /></a> </li>
                                        </ul>
                                        <li className='d-flex text-center'>
                                            <img style={{width:"20px",height:"20px"}} alt="" src={getFlag(i18n.language)} />
                                            <select style={{fontSize:"12px",lineHeight:"10px",borderRadius:"0px",background:"transparent",height:"auto",padding:"0px",width:"60px",textAlign:"center"}} name="lang" onChange={handleChange}>
                                                {i18n.languages.map((lang) => {
                                                return (
                                                    <option className="dark:tw-text-black" key={lang} value={lang}>
                                                    {lang}
                                                    </option>
                                                );
                                                })}
                                            </select>
                                        </li>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTop />
        </>
    )
}

export default FooterTwo;
